export default __webpack_public_path__ + "media/projects/blue1-thumb-d4784adc.svg";